module.exports = __webpack_public_path__ + "static/img/A173.0b53a2a8.jpg";